module.exports = __webpack_public_path__ + "img/lv4.e700aa8e.png";